import React from "react";

const TermsOfUse = () => {
  return (
    <div className="bg-black w-full min-h-[calc(100vh-120px)] py-12">
      <div className="text-gray-400 font-secondary px-8 max-w-[900px] mx-auto md:px-6 sm:px-4 text-left">
        <h1 className="font-primary text-[2.8rem] text-center mb-10 text-white font-bold md:text-[2.2rem] sm:text-[1.8rem]">
          Terms of Use
        </h1>

        <section className="mb-10">
          <p className="text-[1.1rem] leading-[1.7] text-gray-500 mb-4 sm:text-[1rem]">
            Updated on 26th March, 2026
          </p>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            Thank you for using FOZZIL! These Terms of Use apply to your use of
            FOZZIL, T.A.E.L.S, Zypher AI, FOZZIL MEDOS, FOZZIL ARK,
            FOZZIL Store, FOZZIL Ecosystem, and other services provided by
            FOZZIL INDUSTRIES PRIVATE LIMITED, including any associated software
            applications, websites, hardware products, and tools (collectively, the "Services").
            These Terms form a binding agreement between you and FOZZIL, and
            they include important provisions for resolving disputes through
            arbitration. By using the Services, you agree to these Terms. For
            users located in the Asian Countries mainly India, these Terms
            govern your use of the Services. We encourage you to review our
            Privacy Policy, which outlines how we handle personal information.
            While not part of these Terms, it is a vital document you should be
            familiar with.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Who We Are?
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            FOZZIL is an AI research and development company focused on
            transforming industries like healthcare through cutting-edge AI
            solutions. For more information, visit fozzil.in.
          </p>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            T.A.E.L.S is the next level Intelligence in AI systems,
            embedded in FOZZIL's Services, designed to deliver advanced
            AI-powered capabilities.
          </p>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            Zypher AI is an AI system developed by FOZZIL to provide explainable
            artificial intelligence solutions, with a specific focus on the
            healthcare sector.
          </p>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            FOZZIL ARK is a hardware device powered by the T.A.E.L.S Core,
            designed for immersive exhibit experiences. ARK features the Living Ancestor
            Engine for hyper-realistic AI avatar interactions and S.H.A.D.E. Vision
            for spatial awareness.
          </p>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            FOZZIL MEDOS is the world's first AI Hospital Pharmacy Management Operating
            System, designed for clinical and healthcare environments.
          </p>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            FOZZIL Store (store.fozzil.in) is FOZZIL's official e-commerce platform
            for purchasing products, subscriptions, and services.
          </p>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            FOZZIL Ecosystem is a unified network that orchestrates and connects
            all FOZZIL products and services through a single identity (FOZZIL ID).
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Registration and Access
          </h2>
          <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">
            Minimum Age:
          </h3>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            You must be at least 12 years old (or meet the minimum age required
            in your jurisdiction) to use the Services. If you are under 18,
            parental or legal guardian consent is required to use the Services.
          </p>
          <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">
            Registration:
          </h3>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            When registering for an account, you must provide accurate and
            complete information. You are responsible for securing your account
            and cannot share your credentials with others. If you are using the
            Services on behalf of an organization, you must have the authority
            to agree to these Terms on its behalf.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Using Our Services
          </h2>
          <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">
            What You Can Do:
          </h3>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            You are granted permission to access and use the Services in
            compliance with these Terms and applicable laws.
          </p>
          <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">
            What You Cannot Do:
          </h3>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-2 sm:text-[1rem]">
            You may not engage in the following activities:
          </p>
          <ul className="list-disc pl-8 mt-2 mb-4 text-gray-400">
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">
              Use the Services in a manner that violates the rights of others,
              including intellectual property rights.
            </li>
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">
              Copy, modify, sell, or distribute FOZZIL or Zypher AI's Services.
            </li>
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">
              Attempt to reverse engineer or decompile the source code of FOZZIL
              Intelligence or Zypher AI.
            </li>
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">
              Misrepresent AI-generated outputs from T.A.E.L.S or
              Zypher AI as human-generated.
            </li>
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">
              Use outputs from T.A.E.L.S or Zypher AI to create
              competing AI models.
            </li>
          </ul>
          <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">
            Software and Third-Party Services:
          </h3>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            Our Services may allow you to download software, which may update
            automatically to ensure you're using the latest version. Third-party
            software or services integrated with our Services are governed by
            their own terms and conditions. FOZZIL is not responsible for these
            third-party services.
          </p>
          <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">
            Corporate Domains:
          </h3>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            If you create an account using an email address provided by an
            organization (e.g., your employer), that organization may assume
            control of your account. The organization's administrator may gain
            access to your account, including its contents, and restrict your
            access if necessary.
          </p>
          <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">
            Feedback:
          </h3>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            We welcome your feedback on FOZZIL and Zypher AI. By providing
            feedback, you grant FOZZIL the right to use your suggestions without
            any compensation.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Removal of links from our website
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            If you find any link on our Web site or any linked web site
            objectionable for any reason, you may contact us about this. We will
            consider requests to remove links but will have no obligation to do
            so or to respond directly to you.
          </p>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            Whilst we endeavour to ensure that the information on this website
            is correct, we do not warrant its completeness or accuracy; nor do
            we commit to ensuring that the website remains available or that the
            material on the website is kept up to date.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Content
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            You may provide input to FOZZIL's Services ("Input"), and receive
            output from the Services based on the Input ("Output"). Input and
            Output are collectively referred to as "Content." You are
            responsible for all Content you provide, including ensuring it
            complies with applicable laws and FOZZIL's terms. You represent and
            warrant that you have all necessary rights, licenses, and
            permissions to provide Input to our Services.
          </p>
          <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">
            Ownership of Content
          </h3>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            As between you and FOZZIL, and to the extent allowed by law:
          </p>
          <ul className="list-disc pl-8 mt-2 mb-4 text-gray-400">
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">
              You retain ownership of your Input.
            </li>
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">
              You own the Output provided by FOZZIL based on your Input. FOZZIL
              assigns to you all rights, title, and interest, if any, in and to
              the Output. However, this does not include third-party rights or
              other users' output.
            </li>
          </ul>
          <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">
            Similarity of Content
          </h3>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            Due to the nature of FOZZIL's AI services, the Output you receive
            may be similar to that of other users. The assignment of ownership
            to you does not affect other users' rights to their respective
            Outputs.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Our Use of Content
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            FOZZIL may use the Content to provide, maintain, develop, and
            improve its Services. Additionally, Content may be used to comply
            with applicable laws, enforce FOZZIL's terms, and ensure the safety
            and security of our platform.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Accuracy
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            The field of artificial intelligence is evolving rapidly, and while
            FOZZIL strives to provide accurate, reliable, and beneficial
            Services, Outputs may not always be accurate or reflective of actual
            facts.
          </p>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            By using FOZZIL's Services, you agree that:
          </p>
          <ul className="list-disc pl-8 mt-2 mb-4 text-gray-400">
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">
              Outputs may not always be fully accurate, and should not be your
              sole source of truth or factual information.
            </li>
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">
              You must evaluate the accuracy of the Output for your specific use
              case, including using human review when necessary.
            </li>
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">
              You must not use Outputs for legal or material decisions about
              individuals (e.g., credit, employment, education, etc.).
            </li>
          </ul>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            FOZZIL's IP Rights
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            FOZZIL and its affiliates own all rights, title, and interest in and
            to its Services. You may only use FOZZIL's name and logo according
            to its Brand Guidelines.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Payments and Billing
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            By using FOZZIL Pay, you agree that your payment identity is unified across the FOZZIL Ecosystem. Transactions are processed through authorised payment partners and secured with industry-standard encryption to ensure your data remains private and protected.
          </p>
          <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">
            Billing:
          </h3>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            When purchasing FOZZIL Services, you agree to provide accurate
            billing information, including a valid payment method. For
            subscription services, your payment method will be charged
            automatically at each renewal period unless canceled. FOZZIL will
            apply taxes as required.
          </p>
          <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">
            Service Credits:
          </h3>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            Some FOZZIL Services can be purchased in advance through service
            credits, which are subject to FOZZIL's Service Credit Terms.
          </p>
          <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">
            Cancellation:
          </h3>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            You may cancel your paid subscription at any time. Payments are
            non-refundable unless required by law.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Termination and Suspension
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            You may stop using FOZZIL Services at any time. FOZZIL reserves the
            right to suspend or terminate your account for violations of the
            terms or legal requirements, or if your actions pose risks to the
            platform or other users.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Discontinuation of Services
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            FOZZIL reserves the right to discontinue its Services with prior
            notice. If discontinued, any prepaid, unused Services will be
            refunded.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Disclaimer of Warranties
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            FOZZIL provides its Services "as is" without warranties of any kind.
            FOZZIL does not guarantee uninterrupted or error-free services. By
            using the Services, you agree that the Output may not be fully
            accurate, and you should not rely on it as the sole source of truth
            or factual information.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            General Terms
          </h2>
          <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">
            Assignment:
          </h3>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            You may not assign any rights or obligations under these Terms. We
            may assign our rights to any affiliate or successor.
          </p>
          <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">
            Changes to Terms:
          </h3>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            We may update these Terms periodically. We will notify you at least
            30 days in advance of any material changes.
          </p>
          <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">
            Governing Law:
          </h3>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            These Terms are governed by the laws of India, and all claims will
            be brought exclusively in the federal or state courts of Chennai,
            India, except for matters subject to arbitration.
          </p>
        </section>

        <section className="mb-10 text-center border-t border-gray-800 pt-10">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white md:text-[1.5rem] sm:text-[1.3rem]">
            Contact Us
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            If you have any questions or concerns about these Terms,
            please contact us at: <br />
            <span className="text-white font-bold">FOZZIL</span><br />
            Chennai- 603203 Tamil Nadu, India<br />
            <a href="mailto:privacy@fozzil.in" className="text-blue-400 hover:underline">privacy@fozzil.in</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfUse;
